interface DescriptionTemplate {
  prefix: string;
  middle: string;
  suffix: string;
  mood: 'calm' | 'vibrant' | 'dark' | 'light' | 'warm' | 'cool';
}

const descriptionTemplates: DescriptionTemplate[] = [
  // Calm Descriptions
  {
    prefix: 'Gentle',
    middle: 'waves of pastel',
    suffix: 'flowing like silk in the breeze',
    mood: 'calm'
  },
  {
    prefix: 'Serene',
    middle: 'whispers of color',
    suffix: 'drifting through morning mist',
    mood: 'calm'
  },
  {
    prefix: 'Peaceful',
    middle: 'tones',
    suffix: 'melting into tranquil harmony',
    mood: 'calm'
  },
  
  // Vibrant Descriptions
  {
    prefix: 'Electric',
    middle: 'bursts of color',
    suffix: 'dancing in a neon dream',
    mood: 'vibrant'
  },
  {
    prefix: 'Dynamic',
    middle: 'waves of energy',
    suffix: 'pulsing with vibrant life',
    mood: 'vibrant'
  },
  {
    prefix: 'Radiant',
    middle: 'spectrum',
    suffix: 'exploding with chromatic joy',
    mood: 'vibrant'
  },

  // Dark Descriptions
  {
    prefix: 'Mysterious',
    middle: 'shadows',
    suffix: 'swirling in twilight depths',
    mood: 'dark'
  },
  {
    prefix: 'Deep',
    middle: 'cosmic hues',
    suffix: 'echoing through infinite space',
    mood: 'dark'
  },
  {
    prefix: 'Enigmatic',
    middle: 'dark tones',
    suffix: 'weaving through starless nights',
    mood: 'dark'
  },

  // Light Descriptions
  {
    prefix: 'Ethereal',
    middle: 'morning light',
    suffix: 'dancing on crystal waters',
    mood: 'light'
  },
  {
    prefix: 'Delicate',
    middle: 'rays of color',
    suffix: 'floating through cloud-kissed skies',
    mood: 'light'
  },
  {
    prefix: 'Luminous',
    middle: 'wisps',
    suffix: 'gliding on gossamer wings',
    mood: 'light'
  },

  // Warm Descriptions
  {
    prefix: 'Golden',
    middle: 'sunset hues',
    suffix: 'embracing the evening sky',
    mood: 'warm'
  },
  {
    prefix: 'Glowing',
    middle: 'embers',
    suffix: 'painting the desert horizon',
    mood: 'warm'
  },
  {
    prefix: 'Radiant',
    middle: 'autumn tones',
    suffix: 'dancing in harvest light',
    mood: 'warm'
  },

  // Cool Descriptions
  {
    prefix: 'Crystalline',
    middle: 'arctic hues',
    suffix: 'flowing through glacial caves',
    mood: 'cool'
  },
  {
    prefix: 'Fresh',
    middle: 'mountain streams',
    suffix: 'cascading through misty valleys',
    mood: 'cool'
  },
  {
    prefix: 'Pristine',
    middle: 'winter tones',
    suffix: 'whispering through northern lights',
    mood: 'cool'
  }
];

export function getDescriptionForMood(mood: 'calm' | 'vibrant' | 'dark' | 'light' | 'warm' | 'cool'): string {
  const matchingTemplates = descriptionTemplates.filter(template => template.mood === mood);
  if (matchingTemplates.length === 0) return descriptionTemplates[0].prefix + ' ' + descriptionTemplates[0].middle + ' ' + descriptionTemplates[0].suffix;
  
  const template = matchingTemplates[Math.floor(Math.random() * matchingTemplates.length)];
  return `${template.prefix} ${template.middle} ${template.suffix}`;
}

export function getRandomDescription(): string {
  const template = descriptionTemplates[Math.floor(Math.random() * descriptionTemplates.length)];
  return `${template.prefix} ${template.middle} ${template.suffix}`;
}